export default (res) => {
  return new Promise((resolve, reject) => {
    res.json()
      .then(data => resolve({ status: res.status, data }))
      .catch(err => reject(err));
  });
}